export const homeConstants = {
    GET_HOME_TEST_SUCCESS: 'GET_HOME_TEST_SUCCESS',
    GET_HOME_TEST_FAILURE: 'GET_HOME_TEST_FAILURE',
    GET_HOME_TEST_REQUEST: 'GET_HOME_TEST_REQUEST',
};